import axios from '@/lib/axios';
import { PaymentTaskComment, PurchaseOrderContractTaskComment } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1121. 支払タスクコメントリアクションtoggle
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_comments/:id/reactions
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
  emoji_id: string;
  content: string;
};
const paymentTaskCommentReaction = (props: Props): Promise<PaymentTaskComment> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_comments/${props.id}/reactions`,
    props
  );
};

export const usePaymentTaskCommentReaction = () => {
  return useMutation({
    mutationFn: paymentTaskCommentReaction,
  });
};
